import { getScreenshotUrl } from '@mentimeter/screenshots/getScreenshotUrl';
import React from 'react';
import type { ImageProps } from 'src/components/image';
import Image from 'src/components/image';

interface Props extends Omit<ImageProps, 'src'> {
  presentationId: string;
  questionId: string;
}

export const ScreenshotServiceImage = React.memo(
  ({ presentationId, questionId, ...props }: Props) => {
    const imageUrl = getScreenshotUrl({
      presentationId,
      questionId,
      hostname: 'www.mentimeter.com',
      width: 1600,
      height: 900,
    });

    return <Image src={imageUrl} {...props} />;
  },
);
